<template>
  <div>
    <form @submit.prevent="validateBeforeSubmit('formNfeSettings')" data-vv-scope="formNfeSettings" >

      <description-nfe-settings />

      <div class="col-md-3">

        <div class="row">
          <label class="ls-label">
            <span class="ls-label-text col-lg-12">
              {{ $t('settings.label.nfe_setting_days') }}
              <popover class="mb-1" :position="'right'">
                <div slot="content">{{ $t('settings.tooltip.nfe_setting') }}</div>
              </popover>
            </span>
            <div class="col-xs-12 col-md-4 col-sm-4 col-lg-4">
              <authorized-link tag="show_setting">
                <input
                  type="number"
                  v-model="$parent.$data.nfeSettingDays"
                  :required="false"
                  :min="0"
                  :max="30"
                  :name="$t('settings.main.nfe_setting_value')"
                  :placeholder="$t('settings.placeholder.number')" />
              </authorized-link>
            </div>
          </label>
        </div>


        <div class="row">
          <authorized-link tag="show_setting">
            <label class="ls-label">
              <span class="ls-label-text col-lg-12 align-y-center ">
                {{ $t('settings.label.nfe_setting_generate') }}
                <authorized-link tag="show_setting">
                  <input
                    class = "ls-xs-margin-left"
                    type="checkbox"
                    v-model="$parent.$data.nfeSettingGenerate"
                    :required="false"
                  />
                </authorized-link>
              </span>
            </label>
          </authorized-link>
        </div>
        <div class="row" v-if="$parent.$data.nfeSettingGenerate === true">
          <label class="ls-label col-md-6">
            <span class="ls-label-text">
              {{ $t('settings.label.municipal_registration') }}
              <authorized-link tag="show_setting">
                <input
                  type="text"
                  v-model="$parent.$data.municipalRegistration"
                  :required="false"
                />
              </authorized-link>
            </span>
          </label>
        </div>
      </div>

      <div class="col-md-4" v-if="$parent.$data.nfeSettingGenerate === true">
        <h3 class="ls-title-5">{{ $t('settings.main.nfe_gateway_config_title') }}</h3>
        <div v-for="field in gatewayFieldsValues">
          <label class="ls-label">
            <b class="ls-label-text">{{ field.description }}</b>
            <authorized-link tag="show_setting">
              <input type="text" :name="field.tag" v-model="field.data_value">
            </authorized-link>
          </label>
        </div>
      </div>

      <button-submit />

    </form>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import ButtonSubmit from './ButtonSubmit'
  import DescriptionNfeSettings from './DescriptionNfeSettings'
  import Popover from 'src/app/components/shareds/popover/Popover'

  export default {
    components: { ButtonSubmit, DescriptionNfeSettings, Popover },
    methods: {
      ...mapActions(['loadNfeSettings', 'loadBillingSetting', 'loadNfeSetting', 'updateNfeSetting', 'loadGatewayFieldsValues', 'loadSeller']),
      ...mapMutations(['addFlash', 'clearFlash']),
      validateBeforeSubmit (scope) {
        this.clearFlash()
        this.$validator.validateAll(scope).then(success => {
          if (!success || !this.validateQuantityDays()) return
          this.$parent.submitForm()
        })
      },
      populateValues () {
        this.$parent.$data.municipalRegistration = this.seller.municipal_registration
        this.afterLoad()
      },
      afterLoad () {
        this.$loader.hide()
      },
      validateQuantityDays () {
        let valid = true

        if (+this.$parent.$data.nfeSettingDays > this.billingSetting.value) {
          this.addFlash({ message: (this.$t('settings.label.messages.invalid_quantity_days_nfe', { billingSetting: this.billingSetting.value })), type: 'ls-alert-danger' })
          valid = false
        }
        return valid
      },
      loadValues () {
        if (this.$parent.$data.nfeSettingGenerate === true) {
          this.$loader.show()
          this.loadGatewayFieldsValues().then(() => {
            this.populateValues()
          }
          )
        }
      }
    },
    watch: {
      '$parent.$data.nfeSettingGenerate': function () {
        this.loadValues()
      }
    },
    mounted () {
      this.loadValues()
      this.loadBillingSetting(4)
    },
    computed: {
      ...mapGetters(['nfeSetting', 'gatewayFieldsValues', 'billingSetting', 'seller'])
    }
  }
</script>

<style lang="css" scoped>
  .mb-1 {
    margin-bottom: 0.5vh;
  }
  .align-y-center {
    display: flex;
    align-items: center;
  }
</style>




// WEBPACK FOOTER //
// NfeSettings.vue?7299d6c2